import ListItem from '@mui/material/ListItem';
import React, { ReactNode } from 'react';

interface CellRowProps {
  children: ReactNode;
  className?: string;
}

const CellRow = ({ children, className = '' }: CellRowProps) => {
  return (
    <ListItem
      sx={{
        color: 'text.primary',
        minHeight: '48px',
        '&:hover': {
          backgroundColor: 'primary.light'
        }
      }}
      disableGutters
      className={`customCellRow ${className}`}
    >
      {children}
    </ListItem>
  );
};

export default CellRow;
